export const id = 'shift2DY';
export const name = 'Shift 2D Y';
export const DOMAIN_UPDATE_RULES = {
    updateXDomain: false,
    updateYDomain: true,
};
/**
 *
 * @param {Object} datum2d
 * @param {number} [shiftValue=0]
 */
export function apply(datum2D, shiftValue = 0) {
    const data = { ...datum2D.data };
    for (const key in data) {
        data[key].minY += shiftValue;
        data[key].maxY += shiftValue;
    }
}
export function isApplicable() {
    return true;
}
export function reduce(previousValue, newValue) {
    return {
        once: true,
        reduce: previousValue + newValue,
    };
}
//# sourceMappingURL=shiftY.js.map